import { Typography, InputLabel, Box } from '@bluedolphin/ui';
import { ReactNode } from 'react';

export const FormField = ({
    id,
    label,
    children,
}: {
    id: string;
    label: string;
    children: ReactNode;
}) => (
    <Box sx={{ width: '100%' }}>
        <InputLabel
            htmlFor={id}
            sx={{
                pb: 2,
                color: 'rgba(29, 31, 36, 1)',
                fontSize: '14px',
                lineHeight: '22px',
                letterSpacing: '0.1px',
            }}
        >
            <Typography variant="subtitle2">{label}</Typography>
        </InputLabel>
        {children}
    </Box>
);
